import { ca } from '@cian/analytics';

import { type TJsonQuery } from '@/packages/JsonQuery';

export function trackSuburbanCloseSaveSearchClick(sc: TJsonQuery): void {
  ca('eventSite', {
    name: 'oldevent',
    category: 'saved_search',
    action: 'close',
    label: 'window',
    sc,
    useLastProducts: true,
  });
}
